/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { upperFirst } from 'lodash'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function ResidenceField (props: FormTextFieldProps) {
  const { name = 'residence', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'residence',
        defaultMessage: 'Résidence'
      })}
      name={name}
      parser={upperFirst}
      {...others}
    />
  )
}

export default ResidenceField
